<template>
  <nav>
    <router-link to="/">Home</router-link>
    <router-link
      v-if="auth.isLoggedIn && auth.currentRole === 'ADMIN'"
      to="/students"
    >
      學生管理
    </router-link>
    <router-link
      v-if="auth.isLoggedIn && auth.currentRole === 'ADMIN'"
      to="/courses"
    >
      課程管理
    </router-link>
    <router-link
      v-if="auth.isLoggedIn && auth.currentRole === 'ADMIN'"
      to="/exams"
    >
      考試管理
    </router-link>
    <router-link
      v-if="auth.isLoggedIn && (auth.currentRole === 'ADMIN' || auth.currentRole === 'USER')"
      to="/calendar"
    >
      點名表
    </router-link>
    <router-link
      v-if="auth.isLoggedIn && (auth.currentRole === 'ADMIN' || auth.currentRole === 'USER')"
      to="/course-inquiries"
    >
      課程諮詢
    </router-link>
    <router-link v-if="!auth.isLoggedIn" to="/login">登入</router-link>
    <div v-if="auth.isLoggedIn" class="user-menu">
      <router-link
        v-if="auth.currentRole === 'ADMIN' || auth.currentRole === 'USER'"
        to="/profile"
        class="user-link"
      >
        <span>使用者管理</span>
      </router-link>
      <button @click="handleLogout">登出</button>
    </div>
    <div v-if="isDevMode" class="env-indicator">
      ⚠️ DEVELOPMENT MODE ⚠️
    </div>
  </nav>
</template>

<script setup>
import { useRouter } from 'vue-router';
import { useAuthStore } from '@/stores/auth';

const router = useRouter();

const isDevMode = process.env.VUE_APP_MODE === 'development';

// Pinia Store
const auth = useAuthStore();

const handleLogout = () => {
  auth.logout();
  router.push('/login');
};
</script>

<style scoped>
nav {
  padding: 1rem;
  background-color: var(--light-bg);
  border-bottom: 1px solid var(--border-color);
  display: flex;
  align-items: center;
  gap: 1rem;
}

nav a {
  margin: 0 0.5rem;
  text-decoration: none;
  color: var(--text-dark);
  font-size: 0.95rem;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  transition: all 0.2s ease;
}

nav a:hover {
  color: var(--primary-color);
  background-color: rgba(0, 0, 0, 0.05);
}

nav a.router-link-exact-active {
  color: var(--primary-color);
  font-weight: 500;
}

button {
  background: none;
  border: none;
  color: var(--text-dark);
  cursor: pointer;
  font-size: 0.95rem;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
}

button:hover {
  color: var(--primary-color);
  background-color: rgba(0, 0, 0, 0.05);
}

.user-menu {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.env-indicator {
  position: fixed;
  top: 150px;
  left: 10px;
  padding: 8px 15px;
  background-color: #E8D8B8; /* Soft Morandi yellow */
  color: #5A5343; /* Warm dark gray for text */
  font-weight: bold;
  border-radius: 4px;
  border: 1px solid #D0C0A0; /* Subtle Morandi border */
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1); /* Softer shadow */
  animation: subtle-pulse 3s infinite ease-in-out;
  z-index: 9999;
  font-family: monospace;
  letter-spacing: 1px;
  text-transform: uppercase;
  font-size: 14px;
  opacity: 0.9;
}
</style>